module.exports = __webpack_public_path__ + "img/bg34.233e3b9d.jpg";